import React from "react";

export const PageUnderDevelopment = () => {
  return (
    <div>
      <h1>Stránka ve vývoji.</h1>
    </div>
  );
};

